<template>
  <div class="login-wrap">
    <el-card style="width:400px;">
      <h3 style="text-align:center;margin-bottom:20px;">山河印记｜后台管理登录</h3>
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="管理员账号">
          <el-input v-model="form.username" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="form.password" type="password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="login" style="width:100%">登录</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import adminRequest from '@/utils/adminRequest'
export default {
  data() {
    return {
      form: {
        username: '',
        password: ''
      }
    }
  },
  methods: {
    async login() {
      const submitData = {
        username: this.form.username,
        password: this.form.password.trim()
      }
      if (!submitData.username || !submitData.password) {
        this.$message.error('请输入账号和密码')
        return
      }
      try {
        const res = await adminRequest.post('/login', submitData)
        if (res.success && res.code === 200) {
          localStorage.setItem('admin_token', res.data.token)
          this.$message.success('登录成功')
          this.$router.push('/sys-console-x9/user')
        } else {
          this.$message.error(res.msg || '账号或密码错误')
        }
      } catch (err) {
        console.error(err)
        const errorMsg = (err.response && err.response.data && err.response.data.msg) 
                      || (err.data && err.data.msg) 
                      || (err.message) 
                      || "登录失败，请检查网络";
        this.$message.error(errorMsg)
      }
    }
  }
}
</script>
<style scoped>
.login-wrap {
  background: #f5f7fa;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>